<form
  *ngIf="productCode"
  [formGroup]="addToCartForm"
  (submit)="addToCart(); successMsg()"
>
  <div class="quantity" *ngIf="showQuantity">
    <label>{{ "addToCart.quantity" | cxTranslate }}</label>
    <div>
      <cx-item-counter
        [max]="999"
        [control]="addToCartForm.get('quantity')"
      ></cx-item-counter>
    </div>
  </div>

  <div class="pdpwishlist">
    <button
      class="btn btn-primary btn-block"
      type="submit"
      [disabled]="quantity <= 0 || quantity > maxQuantity"
    >
      {{ "addToCart.addToCart" | cxTranslate }}
    </button>
  </div>
</form>
